import { MetricField, MetricUnit } from '@/__generated__/graphql';

export const isMetricUnit = (unit: unknown): unit is MetricUnit => {
  const units = Object.values(MetricUnit);
  const found = units.find((metricUnit) => metricUnit === unit);
  return found !== undefined;
};

export const isMetricField = (metricName: unknown): metricName is MetricField => {
  const values = Object.values(MetricField);
  const found = values.find((value) => value === metricName);
  return found !== undefined;
};
